import * as React from "react";

type DrawerContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

const DrawerContext = React.createContext<DrawerContextValue | undefined>(
  undefined
);

const useDrawer = () => {
  const context = React.useContext(DrawerContext);
  if (context === undefined) {
    throw new Error(`useDrawer must be used within <Drawer />`);
  }

  return context;
};

export { DrawerContext, useDrawer };
